import React, { useEffect, useMemo, useState } from 'react';
import Button from '../../../../generic-components/Button';
import Spinner, { SpinnerColor } from '../../../../generic-components/Spinner';

interface IProps {
    defaultState?: boolean;
    onToggleStatusChange: (mode: boolean) => void;
    isLoading?: boolean;
}

export const ToggleButton = ({ defaultState, onToggleStatusChange, isLoading }: IProps) => {
  const [isActive, setIsActive] = useState<boolean>(false);

  const handleToggle = () => {
    setIsActive(prevState => {
      onToggleStatusChange(!prevState);
      return !prevState;
    });
  };

  const dynamicStyles = useMemo(() => {
    if (!isActive) {
      return {
        wrapper: 'justify-start bg-bw03',
        inner: 'bg-bw06',
      };
    }
    return {
      wrapper: 'justify-end bg-action01',
      inner: 'bg-action03',
    };
  }, [isActive]);

  useEffect(() => {
    if (defaultState !== undefined) {
      setIsActive(defaultState);
    }
  }, [defaultState]);

  return (
    <Button
      childElement={isLoading ? <Spinner containerClassName='rounded-[50%]' spinnerColor={SpinnerColor.Blue} height='16px' width='16px' /> : <span className={`w-[18px] h-[18px] rounded-[50%] transition-all ${dynamicStyles.inner}`} />}
      id='elToggle'
      onClick={handleToggle}
      className={`cursor-pointer hover:shadow-light w-[50px] h-[24px] rounded-[50px] relative flex items-center px-[4px] transition-all ${dynamicStyles.wrapper}`}
    />

  );
};
